module.exports = __webpack_public_path__ + "static/Book5-a31c9fbd3e2dd39b0ae99f19f71a8697.jpg";